<!-- <waitLoading *ngIf="!isLoaded()"> </waitLoading> -->
<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
  <!-- <dossierHeader [projectId]="dossier.identifier" [title]="'Procedures.list' | translate " [titleIcon]="'fa fa-list'">
  </dossierHeader> -->
  <!-- <div class="buttonsHeader">
    <button class="btn btn-outline-secondary" type="button" class="btn btn-outline-secondary" aria-expanded="false" (click)="uiService.routeBack()">
      <i class="fas fa-chevron-left" aria-hidden="true"></i>
      <span class="d-none d-md-inline">
      {{ 'General.back' | translate }}</span>
    </button>
  </div> -->
  <div class="container-fluid  p-0" *ngIf="isLoaded()">
    <div class=" row  m-t-xs" *ngIf="!existData()">
      <span class="alert alert-info col-12"><i class="fas fa-info-circle mr-2" aria-hidden="true"></i>{{
        'General.noData' | translate }}</span>
    </div>
    <div class="row m-t-xs" *ngIf="existData()">
      <div class="col-12 p-0">
        <span class="float-right leyenda"> {{ 'Tasks.showing' | translate }} {{ filteredProcedures ?
          filteredProcedures.length : '0' }} de {{ procedures.length ? procedures.length : '0' }} </span>
      </div>
    </div>
    <div class="row" *ngIf="existData()">
      <div class="col-12 p-0">
        <input pInputText class="p-inputtext" type="text" placeholder="{{ 'Procedures.placeholder' | translate }}"
          name="filterText" id="filterTextInput" [(ngModel)]="textFilter" (ngModelChange)="updateFilter()"
          autocomplete="off" />
      </div>
    </div>
    <div class="row m-t-md" *ngIf="existData()">
      <div class="col-12 p-0">
        <p-treeTable [value]="groupedInfo" [paginator]="true" [rows]="defaultNumberRows"
          [first]="lastPageFirstRecordIndex">
          <ng-template pTemplate="header">
            <tr>
              <th class="text-center LONGTEXTTH"> {{ 'Procedures.procedure' | translate }} </th>
              <th class="text-center LONGTEXTTH"> {{ 'Procedures.hierarchicalDescription' | translate }} </th>
              <th class="d-none d-md-table-cell text-no-overflow DATETH"> {{ 'General.date.ini' | translate }} </th>
              <th class="d-none d-md-table-cell text-no-overflow DATETH"> {{ 'General.date.end' | translate }} </th>
              <th class="USERTH">{{ 'General.user' | translate }}</th>
              <th class="action-column"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
            <tr>
              <td class="text-left LONGTEXT">
                <p-treeTableToggler [rowNode]="rowNode"> </p-treeTableToggler>
                <span pTooltip="{{rowData.identifier?getProcedureDescription(rowData):''}}" tooltipPosition="bottom"><i
                    class="fa {{ getStatusIcon(rowData.status) }} mr-1" aria-hidden="true"></i>
                  <span *ngIf="rowData.identifier" class="{{ getStatusActive(rowData.status) }}"> {{
                    getProcedureDescription(rowData) }} </span>
                </span>
              </td>
              <td class="text-left LONGTEXT">
                <span pTooltip="{{rowData?.startInfo?.origin}}" tooltipPosition="bottom"> {{
                  rowData?.startInfo?.origin}} </span>
              </td>
              <td class="d-none d-md-table-cell text-no-overflow DATE">
                <span *ngIf="rowData.startInfo.date"> {{ rowData.startInfo.date | date: 'dd/MM/y HH:mm' }} </span>
              </td>
              <td class="d-none d-md-table-cell text-no-overflow DATE">
                <span *ngIf="rowData.endDate"> {{ rowData.endDate | date: 'dd/MM/y HH:mm' }} </span>
              </td>
              <td class="USER">
                <ng-container *ngIf="rowData.startInfo.user">
                  <user [user]="rowData.startInfo.user"></user>
                </ng-container>
              </td>
              <td class="action-column">
                <pmenu-actions [dto]="rowData" [lazy]="true" [dtoType]="'PROCEDURE'" (reload)="this.load()"
                  [items]="getProcMenuItem(rowData)">
                </pmenu-actions>
              </td>
            </tr>
          </ng-template>
        </p-treeTable>
      </div>
    </div>
  </div>
</div>